
	function TestPopup(settings){
		this.className = "TestPopup";

		this.name = "start-training";

		if(!settings) settings = {};

		this.data = {
			pages: [
				{
					title: "Test results?",
					name: "test-result",
					static: true,
					onRender: ($wrapper) => {
						const r = this.values;

						$wrapper.find(".js-home").on("click", e => {
							e.preventDefault();
							this.close();
							nav.change(e.currentTarget.getAttribute("href"));
						})

						$wrapper.find(".js-retake").on("click", e => {
							e.preventDefault();
							this.close();
							nav.change(e.currentTarget.getAttribute("href"));
						})

					}
				}
			]
		}

		this.setup(settings);
	};
	TestPopup.inheritsFrom( PopupForm );

